import { useState } from "react";
import { Button, Group, Text } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

export default function ConfirmationModal({
  context,
  id,
  innerProps,
}: ContextModalProps<{
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  color?: string;
  onConfirm: () => Promise<void> | void;
}>) {
  const [loading, setLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    try {
      console.log("23423423");
      setLoading(true);
      //   await innerProps.onConfirm();
      //   context.closeModal(id);
    } catch (err) {
      console.error("Confirmation error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Text size="sm" mb="md">
        {innerProps.message}
      </Text>
      <Group justify="flex-end">
        <Button
          variant="outline"
          color="gray"
          disabled={loading}
          onClick={() => context.closeModal(id)}
        >
          {innerProps.cancelText ?? "Batal"}
        </Button>
        <Button
          loading={loading}
          color={innerProps.color ?? "blue"}
          onClick={handleConfirm}
        >
          {innerProps.confirmText ?? "Ya"}
        </Button>
      </Group>
    </>
  );
}
